import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import SearchView from "../../widgets/SearchView";
import QCTOArtisanSetupSearchForm from '../program/QCTOArtisanSetupSearchForm';
import ViewUtils from '../../ViewUtils';
import withMenuPermission from "../../widgets/withMenuPermission";


const headCells = [
    { id: 'LearnershipCode', numeric: false, disablePadding: true, label: 'Artisan Code' },
    { id: 'LearnershipTitle', numeric: false, disablePadding: true, label: 'Artisan Title' },
    { id: 'ProgrammeStatus', numeric: false, disablePadding: true, label: 'Programme Status' },
    { id: 'CommencementDate', numeric: false, disablePadding: true, label: 'Commencement Date' },
    { id: 'CompletionDate', numeric: false, disablePadding: true, label: 'CompletionDate' },
    { id: 'TradeTestSerialNumber', numeric: false, disablePadding: true, label: 'Serial Number' }
];


const utils = new ViewUtils();
const toolbarRef = React.createRef();

class LearnerQCTOArtisan extends Component {
    constructor(props) {
        super(props);

        console.log(this.props.programmeId);
        this.searchParameters = !utils.isNull(this.props.location.state.learnerID) ? [
            { Name: "LearnershipProgrammeCode", Value: "" },
            { Name: "LearnershipProgrammeDescription", Value: "" },
            { Name: "ProgrammeID", Value: this.props.programmeId },
            { Name: "LearnerID", Value: this.props.location.state.learnerID }
        ]
            :
            [
                { Name: "LearnershipProgrammeCode", Value: "" },
                { Name: "LearnershipProgrammeDescription", Value: "" },
                { Name: "LearnerID", Value: this.props.location.state.learnerID }
            ];

        let model = !utils.isNull(this.props.location.state.learnerID) ?
            {
                LearnershipProgrammeCode: "",
                LearnershipProgrammeDescription: "",
                ProgrammeID: this.props.programmeId,
                LearnerID: this.props.location.state.learnerID

            }
            :
            {
                LearnershipProgrammeCode: "",
                LearnershipProgrammeDescription: "",
                LearnerID: this.props.location.state.learnerID
            }


        if (!utils.isNull(props.exclusions)) {
            model.Exclusions = props.exclusions;
            this.searchParameters.push({ Name: "Exclusions", Value: props.exclusions });
        }



        this.state =
        {
            model: model,
            keyUpSwitch: false,
            selectedLearnerQCTOArtisan: null,
            clearSelectedRow: false

        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'view', label: '', tooltip: 'View', icon: 'ViewIcon', visible: this.props.menuPermissionItem.View, disabled: utils.isNull(this.state.selectedLearnerQCTOArtisan) },
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add, disabled: utils.isNull(this.state.selectedLearnerQCTOArtisan) },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', visible: this.props.menuPermissionItem.Edit, disabled: utils.isNull(this.state.selectedLearnerQCTOArtisan) },
                        { id: "delete", label: "", tooltip: "Remove skills programme", icon: "DeleteIcon", visible: this.props.menuPermissionItem.Delete, disabled: utils.isNull(this.state.selectedLearnerQCTOArtisan) },
                        { id: 'generate', label: 'Generate Agreement', icon: 'DownloadIcon', path: false, tooltip: 'Generate Agreement', disabled: utils.isNull(this.state.selectedLearnerQCTOArtisan) },
                        { id: 'serialno', label: 'Generate Serial Number', icon: 'ExtensionIcon', path: false, tooltip: 'Generate Serial Number', visible: this.props.menuPermissionItem.Edit && ["Administrator", "QA Administrator", "ETQA Manager"].includes(utils.getCurrentRole()), disabled: utils.isNull(this.state.selectedLearnerQCTOArtisan) },
                        { id: 'sor', label: 'Download SOR', icon: 'AssessmentIcon', path: false, tooltip: 'Download SOR', visible: this.props.menuPermissionItem.Edit, disabled: true }
                    ]
                }
            ]
        }

        //TODO: Add url for Artisan removal
        this.deleteUrl = ""
    }


    handleToolbarButtonClick = (buttonId) => {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/learner',
                state: {
                    selection: this.props.location.state.learnerID
                }
            });
        }
        else if (buttonId === "add") {
            this.props.history.push({
                pathname: '/AddLearnerQCTOArtisan',
                state: {
                    LearnerID: this.props.location.state.learnerID,
                    QCTOArtisanID: null,
                    hideFields: true,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.menuPermissionItem
                }
            })
        }
        else if (buttonId === "edit") {
            this.props.history.push({
                pathname: '/AddLearnerQCTOArtisan',
                state: {
                    LearnerID: this.props.location.state.learnerID,
                    QCTOArtisanID: this.state.selectedLearnerQCTOArtisan[0].Id,
                    hideFields: false,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.menuPermissionItem
                }
            })
        }
        else if (buttonId === "view") {
            this.props.history.push({
                pathname: '/AddLearnerQCTOArtisan',
                state: {
                    LearnerID: this.props.location.state.learnerID,
                    QCTOArtisanID: this.state.selectedLearnerQCTOArtisan[0].Id,
                    hideFields: false,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.menuPermissionItem,
                    viewOnly: true
                }
            })
        }

        else if (buttonId === "generate") {
            this.generateDocuments();
            toolbarRef.current.setButtonDisabled("edit", true);
            toolbarRef.current.setButtonDisabled("delete", true);
            toolbarRef.current.setButtonDisabled("generate", true);
            toolbarRef.current.setButtonDisabled("serialno", true);
            toolbarRef.current.setButtonDisabled("sor", true);
        }

        else if (buttonId === "serialno") {
            if (!utils.isNull(this.state.selectedLearnerQCTOArtisan)) {
                this.generateSerialNo();
                toolbarRef.current.setButtonDisabled("edit", true);
                toolbarRef.current.setButtonDisabled("delete", true);
                toolbarRef.current.setButtonDisabled("generate", true);
                toolbarRef.current.setButtonDisabled("serialno", true);
                toolbarRef.current.setButtonDisabled("sor", true);
            }
            else {
                this.setState({ selectedLearnerQCTOArtisan: null, clearSelectedRow: true })
            }
        }

        else if (buttonId === "sor") {
            if (!utils.isNull(this.state.selectedLearnerQCTOArtisan)) {
                this.generateSOR();
                toolbarRef.current.setButtonDisabled("edit", true);
                toolbarRef.current.setButtonDisabled("delete", true);
                toolbarRef.current.setButtonDisabled("generate", true);
                toolbarRef.current.setButtonDisabled("serialno", true);
                toolbarRef.current.setButtonDisabled("sor", true);
            }
            else {
                this.setState({ selectedLearnerQCTOArtisan: null, clearSelectedRow: true })
            }
        }
    }

    generateSerialNo = () => {

        let url = "api/sims/learnerqctoArtisan/GenerateSerialNumber?Id=" + this.state.selectedLearnerQCTOArtisan[0].Id;
        utils.invokeUrl(url, (response) => {
            utils.showMessage(this, response.Message, response.MessageType);
            this.setState({ selectedLearnerQCTOArtisan: null, clearSelectedRow: true, showTable: false }, () => {
                this.setState({ showTable: true })
            })
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    };

    generateDocuments = () => {

        let url = "api/sims/learnerqctoArtisan/GenerateLearnerAgreement?Id=" + this.state.selectedLearnerQCTOArtisan[0].Id;
        utils.invokeUrl(url, (response) => {
            utils.showMessage(this, response.Message, response.MessageType);
            let documentInfo = JSON.parse(response.Message);
            this.FileDownload(documentInfo.OriginalFileName);
            this.setState({ selectedLearnerQCTOArtisan: null, clearSelectedRow: true })
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    };

    generateSOR = () => {

        let url = "api/sims/learnerqctoArtisan/GenerateSOR?Id=" + this.state.selectedLearnerQCTOArtisan[0].Id;
        utils.invokeUrl(url, (response) => {
            utils.showMessage(this, response.Message, response.MessageType);
            let documentInfo = JSON.parse(response.Message);
            this.FileDownload(documentInfo.OriginalFileName);
            this.setState({ selectedLearnerQCTOArtisan: null, clearSelectedRow: true })
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    };

    FileDownload = (documentName) => {

        utils.invokeUrl("api/sims/learnerqctoArtisan/DownloadLearnerAgreement?FileName=" + documentName, (response) => {

            var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
            var url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = response.Name;
            link.target = '_blank';
            link.click();
        }, (e) => {
            this.setState({ messsageAlert: utils.SYSTEM_ERROR_MESSAGE, messageStyle: "outlinedError" });
        }
        );

    };

    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    handleSelection = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedLearnerQCTOArtisan: selection })

            let url = "api/sims/learnerqctoArtisan/CheckCanEditProgramme?Id=" + selection[0].Id;
            utils.invokeUrl(url, (response) => {
                toolbarRef.current.setButtonDisabled("edit", response.Result === "0" ? true : false)
                if (selection[0].ProgrammeStatus === "Completed" || selection[0].ProgrammeStatus === "Registered") {
                    toolbarRef.current.setButtonDisabled("delete", true)
                }
                else {
                    toolbarRef.current.setButtonDisabled("delete", false)
                }
            },
                (e) => {
                    toolbarRef.current.setButtonDisabled("edit", true)
                },
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': "Bearer " + localStorage.getItem("token")
                    }
                }
            )
            if (selection[0].ProgrammeStatus === 'Completed') {
                toolbarRef.current.setButtonDisabled("sor", false)
            }
            else {
                toolbarRef.current.setButtonDisabled("sor", true)
            }
            if (utils.getCurrentRole() === "Provider" || utils.getCurrentRole() === "Agent" || utils.getCurrentRole() === "Employer" || utils.getCurrentRole() === "AET Agent") {
                toolbarRef.current.setButtonDisabled("serialno", true)
            }
            else {
                toolbarRef.current.setButtonDisabled("serialno", false)
            }
        }
        else {
            this.setState({ selectedLearnerQCTOArtisan: null })
        }
    }


    onkeyup(e) {
        //console.log(e.charCode)
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    onClearSelectedRow = () => {
        this.setState({ clearSelectedRow: false });
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="breadcrumbs">
                    {`Learner > QCTO Artisans > ${this.props.location.state.learnerNames}`}
                </p>
                <SearchView headCells={headCells} dataUrl={utils.isNull(this.props.dataUrl) ? "api/sims/learnerqctoArtisan/GetLearnerQCTOArtisanSearch" : this.props.dataUrl}
                    deleteUrl={"api/sims/learnerqctoArtisan/unlinkLearnerQCTOArtisan"} useDeletePost={true}
                    entityViewPath='/AddLearnerQCTOArtisan'
                    model={this.state.model} toolbarConfig={this.toolbarConfig}
                    toolbarRef={toolbarRef}
                    searchParameters={this.searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="ArtisanProgrammeDescription" mode={this.props.mode}
                    history={this.props.history} multiSelect={this.props.multiSelect}
                    hasButtonClickHandler={true} buttonClickHandler={this.handleToolbarButtonClick}
                    keyUpSwitch={this.state.keyUpSwitch}
                    setSelection={(selection) => { this.handleSelection(selection) }}
                    promptTitle={"Remove Learner QCTO Artisan"}
                    promptContent={"Are you sure you want to remove the learner QCTO Artisan record?"} clearSelectedRow={this.state.clearSelectedRow} onClearSelectedRow={this.onClearSelectedRow}
                >
                    <QCTOArtisanSetupSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>
            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(LearnerQCTOArtisan));
